exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bulk-table[data-v-c32fcce8]{overflow:hidden;border:none!important;border-right:1px solid #e8e8e8!important}.bulk-table thead th[data-v-c32fcce8]{font-weight:600;font-size:.75rem;color:#495057;background-color:#f8f9fa;border:none;border-right:1px solid #e8e8e8;padding:1rem 1.25rem;text-transform:uppercase;letter-spacing:.5px}.bulk-table thead th[data-v-c32fcce8]:last-child{border-right:none}.bulk-table tbody tr[data-v-c32fcce8]{-webkit-transition:background-color .2s ease;transition:background-color .2s ease}.bulk-table tbody tr[data-v-c32fcce8]:hover{background-color:#f8f9fa}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-c32fcce8","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/Assets/components/RegistrationCategories/Tickets/Table/BulkTableContainer.vue
// module id = 2499
// module chunks = 1